<template>
<div>
    <base-header v-once pageName="등록완료" :prevBtnShow="true"></base-header>
    
    <section id="wrap">
        <div class="customer-page">
            <div class="complete">
                고객정보 등록을 완료했습니다.
            </div>
            <button type="button" @click="goScheduleReg">일정등록 바로가기</button>
            <button type="button" @click="goCstmrReg">추가 고객등록 바로가기</button>
            <button type="button" @click="goCstmrList">고객목록 바로가기</button>
        </div>
    </section>
</div>
</template>

<script>

export default {
  data(){
      return{
          searchCustNm: "",
          custsrno: "",
      };
  },
    methods: {
        goScheduleReg: function(){
            var parent = {
                name: 'cstmr-list-schedule-reg-param',
                data: 
                {
                    custNm: this.searchCustNm,
                    custDivCd: 'SCD02',
                    kwkkey: this.custsrno
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);

            this.$router.push({ name: 'my-schedule-reg' }).then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.
        },
        goCstmrReg: function(){
            this.$router.push({ path: '/myCstmr/myCstmrReg' });
        },
        goCstmrList: function(){			
            // var searchCustNm = this.searchCustNm;

            // var parent = {
            //     name: 'my-cstmr-list-param',
            //     data: {searchCustNm:searchCustNm}
            // };
            // this.$store.commit("SET_UI_PARENT", parent);
            
            this.$router.push({ path: '/myCstmr/myCstmrList'}).then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.
        },
    },
    mounted() {
        
        var parent = this.$store.getters.parent;
        if(parent.name == 'my-cstmr-reg-result-param'){  // 등록화면에서 등록한 이름
            if("" != parent.data.searchCustNm)
            {
                //console.log("MyCstmrRegResult.vue mounted this.$store.getters.parent.data.searchCustNm", parent.data.searchCustNm);
                this.searchCustNm = parent.data.searchCustNm;
                this.custsrno = parent.data.custsrno;
            }
        }
    },
};
</script>
